import React from 'react'

interface PaymentIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const PaymentIcon: React.FC<PaymentIconProps> = ({
  color = '#888',
  gradient,
  width = 28,
  height = 29,
  alt = 'Payment icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 28 29'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <g fill={gradient ? 'url(#grad1)' : color} clipPath='url(#clip0_6142_10367)'>
        <path d='M14 .429c-7.718 0-14 6.278-14 14 0 7.717 6.282 14 14 14s14-6.283 14-14c0-7.722-6.282-14-14-14zm12.364 14c0 6.816-5.548 12.363-12.364 12.363-6.816 0-12.364-5.547-12.364-12.363C1.636 7.612 7.184 2.065 14 2.065c6.816 0 12.364 5.547 12.364 12.364z'></path>
        <path d='M16.398 10.452c.87 0 1.579.709 1.579 1.58 0 .45.367.817.818.817a.82.82 0 00.818-.818 3.22 3.22 0 00-3.215-3.216h-1.58V6.642A.82.82 0 0014 5.823a.82.82 0 00-.818.818V8.82h-1.58A3.22 3.22 0 008.4 12.35c.158 1.628 1.606 2.901 3.303 2.901h1.475v3.159h-1.58c-.87 0-1.58-.709-1.58-1.58a.82.82 0 00-.817-.818.82.82 0 00-.818.819 3.22 3.22 0 003.215 3.215h1.58v2.179c0 .45.367.818.818.818a.82.82 0 00.818-.818v-2.179h1.474c1.698 0 3.146-1.273 3.303-2.9a3.221 3.221 0 00-3.203-3.53H14.81v-3.16h1.589v-.004zm-1.58 7.954v-3.16h1.58c.441 0 .87.189 1.168.517.302.333.446.766.402 1.22-.079.797-.814 1.422-1.675 1.422h-1.475zm-1.636-7.954v3.159h-1.474c-.862 0-1.597-.626-1.676-1.422-.044-.455.1-.889.402-1.221a1.584 1.584 0 011.169-.516h1.579z'></path>
      </g>
      <defs>
        <clipPath id='clip0_6142_10367'>
          <path fill='#fff' d='M0 0H28V28H0z' transform='translate(0 .429)'></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default PaymentIcon
